var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScreenType(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.232,
    height: 19.352,
    viewBox: "0 0 20.232 19.352",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_000000ff",
    "data-name": "#000000ff",
    transform: "translate(-169.379 -587.39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1754",
    "data-name": "Path 1754",
    d: "M128.614,74.686a1.037,1.037,0,0,1,.326-.046c3,0,6,0,8.993,0a1.028,1.028,0,0,1,.889,1.106q0,8.317,0,16.634a1.029,1.029,0,0,1-.89,1.108q-4.538,0-9.077,0a1.027,1.027,0,0,1-.891-1.1q0-8.293,0-16.586a1.124,1.124,0,0,1,.651-1.116m.473,1.065q0,8.317,0,16.637h8.5q0-8.317,0-16.638Z",
    transform: "translate(46.102 513)",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1755",
    "data-name": "Path 1755",
    d: "M85.664,106.67a.559.559,0,0,1,.748.547q0,7.179,0,14.358a.554.554,0,1,1-1.107,0q0-7.045,0-14.089a1.472,1.472,0,0,1,.044-.505A.559.559,0,0,1,85.664,106.67Z",
    transform: "translate(86.544 482.671)",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1756",
    "data-name": "Path 1756",
    d: "M405.667,106.672a.559.559,0,0,1,.749.547q0,7.15,0,14.3a.622.622,0,0,1-.149.461.557.557,0,0,1-.791.023.606.606,0,0,1-.171-.481q0-7.149,0-14.3A.561.561,0,0,1,405.667,106.672Z",
    transform: "translate(-219.273 482.669)",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1757",
    "data-name": "Path 1757",
    d: "M42.977,138.73a.557.557,0,0,1,.676.219,1.08,1.08,0,0,1,.088.588q0,5.382,0,10.765a.559.559,0,0,1-.465.575.551.551,0,0,1-.627-.426,3.309,3.309,0,0,1-.016-.518q0-5.327,0-10.655A.565.565,0,0,1,42.977,138.73Z",
    transform: "translate(127 452.28)",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1758",
    "data-name": "Path 1758",
    d: "M448.341,138.664a.559.559,0,0,1,.731.559q0,5.378,0,10.758a.979.979,0,0,1-.117.635.556.556,0,0,1-.756.115.592.592,0,0,1-.237-.537q0-5.485,0-10.97A.56.56,0,0,1,448.341,138.664Z",
    transform: "translate(-259.713 452.334)",
    stroke: "#000",
    strokeWidth: 0.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenType);
export default __webpack_public_path__ + "static/media/ScreenType.950157b49cc6348715a869b169f845f6.svg";
export { ForwardRef as ReactComponent };